import Locations from './Locations'
import AddressDetail from './AddressDetail'
import LocationsSerch from './LocationsSerch'

export { AddressDetail, LocationsSerch }

export default Locations
